
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import TimeSelect from "./TimeSelect";
import CategorySelect from "./CategorySelect";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const DAYS = [
  { id: 'monday', label: 'Mon' },
  { id: 'tuesday', label: 'Tue' },
  { id: 'wednesday', label: 'Wed' },
  { id: 'thursday', label: 'Thu' },
  { id: 'friday', label: 'Fri' },
  { id: 'saturday', label: 'Sat' },
  { id: 'sunday', label: 'Sun' },
] as const;

interface TimeSlotItemProps {
  time: string;
  categoryId: string | null;
  days?: {
    [key: string]: boolean;
  };
  selectedCategories: string[];
  showRandomOption?: boolean;
  onTimeChange: (hours: string, minutes: string) => void;
  onCategoryChange: (categoryId: string | null) => void;
  onDaysChange?: (day: string, checked: boolean) => void;
  onRemove: () => void;
}

export default function TimeSlotItem({
  time,
  categoryId,
  days = {},
  selectedCategories,
  showRandomOption = false,
  onTimeChange,
  onCategoryChange,
  onDaysChange,
  onRemove
}: TimeSlotItemProps) {
  const [hours, minutes] = time.split(':');
  
  const handleTimeChange = (newHours: string, newMinutes: string) => {
    onTimeChange(
      newHours.padStart(2, '0'),
      newMinutes.padStart(2, '0')
    );
  };

  return (
    <div className="flex flex-col gap-4 p-4 border rounded-lg bg-card">
      <div className="flex flex-wrap items-center gap-4">
        <TimeSelect
          hours={hours}
          minutes={minutes}
          onChange={handleTimeChange}
        />
        
        <CategorySelect
          categoryId={categoryId}
          selectedCategories={selectedCategories}
          onCategoryChange={onCategoryChange}
          showRandomOption={showRandomOption}
        />
        
        <Button 
          variant="outline" 
          size="icon"
          onClick={onRemove}
          className="ml-auto"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
      
      {onDaysChange && (
        <div className="flex flex-wrap gap-4 mt-2">
          {DAYS.map((day) => (
            <div key={day.id} className="flex items-center space-x-2">
              <Checkbox
                id={`${time}-${day.id}`}
                checked={days[day.id] ?? true}
                onCheckedChange={(checked) => onDaysChange(day.id, checked as boolean)}
              />
              <Label
                htmlFor={`${time}-${day.id}`}
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                {day.label}
              </Label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
